export enum TrackSourceType {
	WEB = 'WEB',
	MOBILE = 'MOBILE',
	UNKNOWN = 'UNKNOWN',
}
